<template>
  <address-dadata
    v-if="addressProvider==='dadata'"
    :inputStyle="inputStyle"
    :name="name"
    :model="model"
    :required="required"
    :modalVariableName="modalVariableName"
    :tabView="tabView"
    :placeholder="placeholder"
    :disabled="disabled"

    :onChangeValidation="onChangeValidation"
    :formValidator="formValidator"
    :addressIdFieldName="addressIdFieldName"
    :addressData="addressData"
    :houseFiasFieldName="houseFiasFieldName"
    :fiasFieldName="fiasFieldName"
    :validateAlias="validateAlias"
    :geoFields="geoFields"
    :callbacks="callbacks"

    :onValidate="onValidate"

    @click="onClick"
    @blur="onBlur"
    @change="change"
    @input="onInput"
    @selectItem="onSelect"

    class="e-address"
  ></address-dadata>
  <address-nominatim
    v-else-if="addressProvider==='nominatim'"
    :inputStyle="inputStyle"
    :name="name"
    :model="model"
    :required="required"
    :modalVariableName="modalVariableName"
    :tabView="tabView"
    :placeholder="placeholder"
    :disabled="disabled"

    :onChangeValidation="onChangeValidation"
    :formValidator="formValidator"
    :addressIdFieldName="addressIdFieldName"
    :addressData="addressData"
    :houseFiasFieldName="houseFiasFieldName"
    :fiasFieldName="fiasFieldName"
    :validateAlias="validateAlias"
    :geoFields="geoFields"
    :callbacks="callbacks"

    :onValidate="onValidate"

    @click="onClick"
    @blur="onBlur"
    @change="change"
    @input="onInput"
    @selectItem="onSelect"

    class="e-address"
  ></address-nominatim>
  <address-custom
    v-else-if="addressProvider==='custom'"
    :inputStyle="inputStyle"
    :name="name"
    :model="model"
    :required="required"
    :modalVariableName="modalVariableName"
    :tabView="tabView"
    :placeholder="placeholder"
    :disabled="disabled"

    :onChangeValidation="onChangeValidation"
    :formValidator="formValidator"
    :addressIdFieldName="addressIdFieldName"
    :addressData="addressData"
    :houseFiasFieldName="houseFiasFieldName"
    :fiasFieldName="fiasFieldName"
    :validateAlias="validateAlias"
    :geoFields="geoFields"
    :callbacks="callbacks"

    :onValidate="onValidate"

    @click="onClick"
    @blur="onBlur"
    @change="change"
    @input="onInput"
    @selectItem="onSelect"

    class="e-address"
  ></address-custom>
  <address-tree
    v-else-if="addressProvider==='tree'"
    :inputStyle="inputStyle"
    :name="name"
    :model="model"
    :required="required"
    :modalVariableName="modalVariableName"
    :tabView="tabView"
    :placeholder="placeholder"
    :disabled="disabled"

    :onChangeValidation="onChangeValidation"
    :formValidator="formValidator"
    :addressIdFieldName="addressIdFieldName"
    :addressData="addressData"
    :houseFiasFieldName="houseFiasFieldName"
    :fiasFieldName="fiasFieldName"
    :validateAlias="validateAlias"
    :geoFields="geoFields"
    :callbacks="callbacks"

    :onValidate="onValidate"
    :treeAttributes="treeAttributes"

    @click="onClick"
    @blur="onBlur"
    @change="change"
    @input="onInput"

    class="e-address"
  ></address-tree>
  <div v-else>
    Unknown address provider
  </div>
</template>

<script>
  import {DEFAULT_ADDRESS_PROVIDER} from "../../config/config"
  import AddressDadata from "./address-dadata"
  import AddressNominatim from "./address-nominatim"
  import AddressCustom from "./address-custom";
  import AddressTree from "./address-tree";

  // data-* attributes used for debug
  export default {
    name: 'e-address',
    components: {AddressTree, AddressCustom, AddressNominatim, AddressDadata},
    data () {
      return {
        error: null
      }
    },
    props: {
      inputStyle: {
        type: Object,
        default: () => {}
      },
      onChangeValidation: {
        type: Boolean,
        default: false
      },
      formValidator: null,
      model: {
        type: Object,
        required: true
      },
      tabView: {
        type: String,
        default: null
      },
      name: {
        type: String,
        default: null,
        required: true
      },
      validateAlias: {
        type: String,
        default: null
      },
      required: {
        type: Boolean,
        default: false
      },
      modalVariableName: {
        type: String,
        default: null
      },
      disabled: {
        type: Boolean,
        default: false
      },
      placeholder: {
        type: String,
        default: null
      },
      onValidate: {
        type: Function,
        default: (obj) => obj
      },
      addressData: {
        type: Object,
        required: true,
        default: function () {
          return {}
        }
      },
      // исп в src/components/form/form-base-mixin.js
      // в saveAddressData, поскольку сначала сохраняется адрес
      // затем его id нужно проставить у создавемой записи
      addressIdFieldName: {
        type: String,
        default: 'address_id'
      },
      // если не нул будет валидация успешной если есть fias с номером дома
      houseFiasFieldName: {
        type: String,
        default: null
      },
      fiasFieldName: {
        type: String,
        default: null
      },
      geoFields: {
        type: Array
      },
      callbacks: {
        type: Object
      },
      // 'nominatim' | 'dadata' | 'custom' | 'tree'
      addressProvider: {
        type: String,
        default: DEFAULT_ADDRESS_PROVIDER
      },
      treeAttributes: {
        type: Object,
        default: () => {}
      }
    },
    methods: {
      onClick (evt) {
        this.$emit('click', evt)
      },
      onSelect (evt) {
        this.$emit('selectItem', evt)
      },
      onEnter ($event) {
        this.$emit('enter', $event)
      },
      onBlur ($event) {
        this.$emit('blur', $event)
      },
      onInput (e) {
        this.$emit('input', e)
      },
      change ($event) {
        this.$emit('change', $event)
      }
    }
  }
</script>
